module.exports = __webpack_public_path__ + "img/2_241.5834b78a.png";